module.exports = __webpack_public_path__ + "img/icon-map-implantation-09.18c74f7f.svg";